
import Button from '@/models/ButtonModel';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
	name: 'persistent-button',

	props: {
		button: {
			type: Object as PropType<Button>
		}
	},

	emits: ['click'],

	computed: {
		isPhoneSize(): boolean {
			return this.$q.screen.name === 'xs';
		}
	}
});
